import React from 'react';
import { LinearProgress, Typography } from '@mui/material';
import './ProgressBar.css';

const ProgressBar = ({ progress, isProcessing, hasFiles }) => {
  if (!hasFiles || (!isProcessing && progress === 0)) {
    return null;
  }

  const isComplete = progress >= 100;
  const containerClass = `progress-bar-container card ${isComplete ? 'complete' : 'processing'}`;

  return (
    <div 
      className={containerClass}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={isComplete ? 'Processing Complete' : `Processing Documents: ${Math.round(progress)}%`}
    >
      <LinearProgress
        className="progress-bar"
        variant="determinate"
        value={Math.min(progress, 100)}
      />
      <Typography className="progress-text">
        {isComplete ? 'Processing Complete' : `Processing Documents: ${Math.round(progress)}%`}
      </Typography>
      
      {!isComplete && (
        <div className="progress-dots">
          <div className="progress-dot"></div>
          <div className="progress-dot"></div>
          <div className="progress-dot"></div>
        </div>
      )}

      <span className="progress-percentage" aria-hidden="true">
        {Math.round(progress)}%
      </span>
    </div>
  );
};

export default ProgressBar;
